// Helper function to calculate classification from ELO rating
export const getClassificationForElo = (elo: number, isFemale: boolean = false): string => {
  if (isFemale) {
    // Women's (Damen) classification
    if (elo >= 1790) return "A22";
    if (elo >= 1680) return "A21";
    if (elo >= 1435) return "A20";
    if (elo >= 1360) return "A19";
    if (elo >= 1280) return "A18";
    if (elo >= 1240) return "A17";
    if (elo >= 1200) return "A16";
    if (elo >= 1150) return "B15";
    if (elo >= 1100) return "B14";
    if (elo >= 1050) return "B13";
    if (elo >= 990) return "B12";
    if (elo >= 930) return "B11";
    if (elo >= 890) return "C10";
    if (elo >= 840) return "C9";
    if (elo >= 790) return "C8";
    if (elo >= 740) return "C7";
    if (elo >= 700) return "C6";
    if (elo >= 675) return "D5";
    if (elo >= 650) return "D4";
    if (elo >= 630) return "D3";
    if (elo >= 615) return "D2";
    return "D1";
  } else {
    // Men's (Herren) classification
    if (elo >= 1990) return "A22";
    if (elo >= 1890) return "A21";
    if (elo >= 1790) return "A20";
    if (elo >= 1680) return "A19";
    if (elo >= 1565) return "A18";
    if (elo >= 1490) return "A17";
    if (elo >= 1435) return "A16";
    if (elo >= 1360) return "B15";
    if (elo >= 1320) return "B14";
    if (elo >= 1280) return "B13";
    if (elo >= 1240) return "B12";
    if (elo >= 1200) return "B11";
    if (elo >= 1150) return "C10";
    if (elo >= 1100) return "C9";
    if (elo >= 1050) return "C8";
    if (elo >= 990) return "C7";
    if (elo >= 930) return "C6";
    if (elo >= 860) return "D5";
    if (elo >= 780) return "D4";
    if (elo >= 700) return "D3";
    if (elo >= 630) return "D2";
    return "D1";
  }
};

// Helper function to format classification display
// API returns formats like "C8", "B8", "A20" etc.
// This keeps the full format with the sublevel number
export const formatClassification = (classification: string | undefined): string => {
  if (!classification) return '-';

  // Already in correct format (e.g., "C8", "B15", "A20")
  // Just ensure it's uppercase
  return classification.toUpperCase();
};

// Helper function to get classification color based on the app's theme
// Colors match mobile app exactly from Theme.kt
export const getClassificationColor = (classification: string): { bg: string; text: string } => {
  const letter = classification?.charAt(0);
  switch (letter) {
    case 'A':
      return { bg: '#1A1A1A', text: '#FFFFFF' }; // AColor - Soft black for elite A-class
    case 'B':
      return { bg: '#9C27B0', text: '#FFFFFF' }; // BColor - Purple for B-class
    case 'C':
      return { bg: '#F59E0B', text: '#FFFFFF' }; // CColor - Vibrant orange for C-class
    case 'D':
      return { bg: '#1C7AD6', text: '#FFFFFF' }; // DColor - Blue for entry-level D-class
    default:
      return { bg: '#1C7AD6', text: '#FFFFFF' }; // Default blue (BluePrimary)
  }
};
